// src/hooks/useAdminSession.ts
import { useMutation } from "@tanstack/react-query";
import api from "../api"; // your axios instance

interface AdminSessionRequest {
  refresh_token: string;
}

interface AdminSessionResponse {
  statusCode: number;
  refresh_token?: string;
  accessToken?: string;
  expires_in?: number;
  message?: string;
  errorDesc?: string;
}

export const useAdminSession = () =>
  useMutation<AdminSessionResponse, Error, AdminSessionRequest>({
    mutationFn: async ({ refresh_token }) => {
      const { data } = await api.post<AdminSessionResponse>(
        "/admin-session/v1",
        { refresh_token }
      );
      return data;
    },
  });
